var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommunity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0609 17.223C21.1608 17.3785 21.3053 17.4999 21.4719 17.5799C22.7455 18.1912 23.6247 19.4929 23.6247 21V23.3333C23.6247 23.8166 24.0165 24.2083 24.4997 24.2083C24.983 24.2083 25.3747 23.8166 25.3747 23.3333V21C25.3747 17.9394 22.8936 15.4583 19.833 15.4583C19.7062 15.4583 19.6491 15.6219 19.745 15.7049C20.2528 16.1444 20.6967 16.6557 21.0609 17.223Z",
    fill: "#626768"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.16667 17.2083C6.07259 17.2083 4.375 18.9059 4.375 21V23.3333C4.375 23.8166 3.98325 24.2083 3.5 24.2083C3.01675 24.2083 2.625 23.8166 2.625 23.3333V21C2.625 17.9394 5.10609 15.4583 8.16667 15.4583H15.1667C18.2272 15.4583 20.7083 17.9394 20.7083 21V23.3333C20.7083 23.8166 20.3166 24.2083 19.8333 24.2083C19.3501 24.2083 18.9583 23.8166 18.9583 23.3333V21C18.9583 18.9059 17.2607 17.2083 15.1667 17.2083H8.16667Z",
    fill: "#626768"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.349 11.1504C17.4528 10.9531 17.6177 10.7956 17.8098 10.6826C18.6717 10.1758 19.2501 9.23877 19.2501 8.16667C19.2501 7.09457 18.6717 6.15757 17.8098 5.65074C17.6177 5.53775 17.4528 5.38021 17.349 5.18295C17.059 4.63179 16.6911 4.12798 16.2601 3.68613C16.1927 3.6171 16.237 3.5 16.3334 3.5C18.9108 3.5 21.0001 5.58934 21.0001 8.16667C21.0001 10.744 18.9108 12.8333 16.3334 12.8333C16.237 12.8333 16.1927 12.7162 16.2601 12.6472C16.6911 12.2054 17.059 11.7015 17.349 11.1504Z",
    fill: "#626768"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6667 11.0833C13.2775 11.0833 14.5833 9.7775 14.5833 8.16667C14.5833 6.55584 13.2775 5.25 11.6667 5.25C10.0558 5.25 8.75 6.55584 8.75 8.16667C8.75 9.7775 10.0558 11.0833 11.6667 11.0833ZM11.6667 12.8333C14.244 12.8333 16.3333 10.744 16.3333 8.16667C16.3333 5.58934 14.244 3.5 11.6667 3.5C9.08934 3.5 7 5.58934 7 8.16667C7 10.744 9.08934 12.8333 11.6667 12.8333Z",
    fill: "#626768"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity);
export default __webpack_public_path__ + "static/media/community.3b6bdf6b989feb576372af985c05fa40.svg";
export { ForwardRef as ReactComponent };